import { render, staticRenderFns } from "./flange-element.vue?vue&type=template&id=68d9e16f"
import script from "./flange-element.vue?vue&type=script&lang=js"
export * from "./flange-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports